import { CloudUploadOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { FC } from "react";

import BaseButton from "@/components/BaseButton";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import { StyledConfirmButton, StyledWarningTriangle } from "./Styled";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm?: () => void;
}

const MidnightWarning: FC<Props> = ({ isOpen, onClose, onConfirm }) => {
    return (
        <Modal open={isOpen} onCancel={onClose} centered footer={null}>
            <StyledWarningTriangle />

            <PrimaryText
                fontSize={20}
                fontWeight="500"
                textAlign="center"
                padding="0 0 16px"
            >
                Є невивантажені дані
            </PrimaryText>

            <PrimaryText padding="0 0 12px">
                Будь ласка, вивантажте дані на сервер або надішліть файл із
                даними в чат підтримки, якщо вивантаження неможливе.
            </PrimaryText>

            <PrimaryText padding="0 0 16px">
                Для цього натисніть на іконку хмари <CloudUploadOutlined />
            </PrimaryText>

            <SecondaryText padding="0 0 20px">
                Якщо цього не зробити, після <b>00:00</b> дані буде видалено без
                можливості відновлення. Фотографії буде збережено.
            </SecondaryText>

            {onConfirm && (
                <StyledConfirmButton type="primary" onClick={onConfirm}>
                    Вивантажити дані
                </StyledConfirmButton>
            )}

            <BaseButton type="default" marginTop="16px" onClick={onClose}>
                Повернутися назад
            </BaseButton>
        </Modal>
    );
};

export default MidnightWarning;
